module.exports = __webpack_public_path__ + "static/media/boyle-construction.8d3e3f71.jpg";